// src/hooks/useTransactions.js
// ─────────────────────────────────────────────────────────
// Real-time transactions. Filtered to the active project.
// ─────────────────────────────────────────────────────────

import { useState, useEffect, useMemo } from 'react';
import {
  subscribeToTransactions,
  addTransaction,
  updateTransaction,
  deleteTransaction,
} from '../lib/db';

export function useTransactions(uid, projectId) {
  const [all, setAll]       = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!uid) return;
    setLoading(true);
    const unsub = subscribeToTransactions(uid, (data) => {
      setAll(data);
      setLoading(false);
    });
    return unsub;
  }, [uid]);

  // Only the transactions that belong to the active project
  const transactions = useMemo(() => {
    if (!projectId) return [];
    return all
      .filter(t => t.projectId === projectId)
      .sort((a, b) => new Date(b.date) - new Date(a.date));
  }, [all, projectId]);

  const add    = (data)     => addTransaction(uid, { ...data, projectId });
  const update = (id, data) => updateTransaction(uid, id, data);
  const remove = (id)       => deleteTransaction(uid, id);

  return { transactions, loading, add, update, remove };
}